// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_SPACE } from "./action";

export function canDeleteSpace(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_SPACE);
}
